export const login = {
  oktaLogin: 'Login with Okta',
  logoAltText: 'Hinge Health',
  loginFailure:
    'An unexpected error occurred, and we could not log you in. Please try again in a few minutes.',
  unauthorizedLogin: 'Unable to login. You are not authorized.',
};
